import { Config } from '@core/models/config.model';
import { createAction, props } from '@ngrx/store';

export const fullUpdateConfig = createAction('[Config] Full Update', props<{ newConfig: Config }>());
